// extracted by mini-css-extract-plugin
module.exports = {"container":"LivesScreen_container__wKZqR","title":"LivesScreen_title__1fv02","day":"LivesScreen_day__3fM64"};